import { ICellRendererParams } from '@ag-grid-community/core';

import { DataGridAction } from './data-grid-action';

export interface DataGridActionRendererParams extends ICellRendererParams {
  // actions: CustomGridAction[];
  context: { actions: DataGridAction[] };
}
